exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".input[data-v-53f479a5]{margin:1.875rem auto 0;max-width:20rem}button[data-v-53f479a5]{background-color:#fff}button[data-v-53f479a5] :hover{background-color:#3b3b3a}", ""]);

